import { DaysToDeliveryFieldsNames } from "globalConstants";

import { createCustomEnum } from "./customEnum";

const DaysToDeliveryTypes = createCustomEnum({
	SameDay: {
		value: 0,
		name: DaysToDeliveryFieldsNames.SameDay.beName,
		displayName: DaysToDeliveryFieldsNames.SameDay.displayName,
	},
	OneThreeDays: {
		value: 1,
		name: DaysToDeliveryFieldsNames.OneThreeDays.beName,
		displayName: DaysToDeliveryFieldsNames.OneThreeDays.displayName,
	},
	FourSevenDays: {
		value: 2,
		name: DaysToDeliveryFieldsNames.FourSevenDays.beName,
		displayName: DaysToDeliveryFieldsNames.FourSevenDays.displayName,
	},
	EightFourteenDays: {
		value: 3,
		name: DaysToDeliveryFieldsNames.EightFourteenDays.beName,
		displayName: DaysToDeliveryFieldsNames.EightFourteenDays.displayName,
	},
	FifteenThirtyDays: {
		value: 4,
		name: DaysToDeliveryFieldsNames.FifteenThirtyDays.beName,
		displayName: DaysToDeliveryFieldsNames.FifteenThirtyDays.displayName,
	},
	ThirtyPlusDays: {
		value: 5,
		name: DaysToDeliveryFieldsNames.ThirtyPlusDays.beName,
		displayName: DaysToDeliveryFieldsNames.ThirtyPlusDays.displayName,
	},
	DaysOverThirty: {
		value: 6,
		name: DaysToDeliveryFieldsNames.DaysOverThirty.beName,
		displayName: DaysToDeliveryFieldsNames.DaysOverThirty.displayName,
	},
});

export default DaysToDeliveryTypes;
